import React, {useState} from 'react';

const DATE = 1641240200331;

const Banner = () => {
  const cancelDate = localStorage.getItem('banner');
  const [isHidden, setIsHidden] = useState(false);

  if (parseInt(cancelDate) > DATE)
    return null;

  const onClear = (e) => {
    localStorage.setItem('banner', new Date().getTime().toString());
    setIsHidden(true)
    e.stopPropagation();
  }

  return isHidden ? null : <div
    className="page-banner tr-page-banner bg-purple white mt-1 pt-2 pb-2 pe-5 pe-md-0 text-center w-100 cursor-pointer position-relative"
    onClick={() => window.open('/affiliates', "_blank")}
  >
    Introducing our new affiliate program - earn when you refer us -
    <span className="link-white"><u>Join</u></span>
    <div
      className="cursor-pointer position-absolute"
      onClick={onClear}
      style={{top: 5, right: 15}}
    >
      <img src="assets/icons/cancel_white.svg" height={15}/>
    </div>
  </div>
}

export default Banner;